"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("./defineProperty-b53f90b9.js"),
  r = require("./breakpoints-359d04f5.js"),
  t = require("./colors-c0f39aa2.js"),
  n = require("./gradients-74ddcb08.js"),
  a = require("polished/lib/helpers/rem"),
  o = require("./slicedToArray-a539bf82.js"),
  i = require("react");
function s(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
require("./_commonjsHelpers-f10b257f.js"), require("./toPropertyKey-ec4a2a72.js"), require("polished/lib/helpers/em"), require("polished/lib/color/shade");
var u = s(a),
  l = {
    transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
    dp2: "0 2px 8px 0 rgba(0, 0, 0, 0.1)",
    dp4: "0 4px 16px 0 rgba(0, 0, 0, 0.1)",
    dp8: "0 8px 32px 0 rgba(0, 0, 0, 0.3)",
    hover: "0 0 10px rgb(0 0 0 / 7%), 0 2px 10px rgb(0 0 0 / 10%)",
    inner: "inset 0px -6px 6px 0 rgba(0, 0, 0, 0.1)"
  },
  p = {
    gradients: n.gradients,
    shadows: l
  },
  c = {
    xxxxxlarge: 72,
    xxxxlarge: 60,
    xxxlarge: 48,
    xxlarge: 40,
    xlarge: 32,
    large: 28,
    medium: 24,
    small: 20,
    xsmall: 16,
    xxsmall: 12,
    xxxsmall: 8,
    xxxxsmall: 4
  };
function b(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function d(r) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  "undefined" == typeof window && (global.window = {
    matchMedia: function matchMedia() {
      return {
        matches: {}
      };
    }
  });
  var n = r.replace(/^@media( ?)/m, ""),
    a = "undefined" != typeof window && void 0 !== window.matchMedia,
    s = function (r) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? b(Object(n), !0).forEach(function (t) {
          e._defineProperty(r, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
          Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return r;
    }({}, t),
    u = s.defaultMatches,
    l = void 0 !== u && u,
    p = s.matchMedia,
    c = void 0 === p ? a ? window.matchMedia : null : p,
    d = s.noSsr,
    f = void 0 !== d && d,
    m = s.ssrMatchMedia,
    g = void 0 === m ? null : m,
    k = i.useState(function () {
      return f && a ? c(n).matches : g ? g(n).matches : l;
    }),
    x = o._slicedToArray(k, 2),
    h = x[0],
    w = x[1];
  return i.useEffect(function () {
    var e = !0;
    if (!a) return function () {};
    var r = c(n),
      t = function t() {
        e && w(r.matches);
      };
    return t(), r.addListener(t), function () {
      e = !1, r.removeListener(t);
    };
  }, [n, c, a]), i.useEffect(function () {}, ["production"]), h;
}
var f = 300,
  m = 400,
  g = {
    globalNav: f,
    globalNavLogo: 321,
    globalNavMain: 320,
    globalNavOverlay: 310,
    globalNavPrimary: 330,
    informationalBanner: 350,
    modal: 600,
    modalMain: 620,
    modalOverlay: 610,
    recaptchaBadge: 500,
    search: m,
    searchControls: 430,
    searchMain: 420,
    searchMainResults: 421,
    searchOverlay: 410,
    skipNav: 360,
    stickyBanner: 210,
    toast: 200,
    toolTip: 20
  };
function k(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function x(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? k(Object(n), !0).forEach(function (t) {
      e._defineProperty(r, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return r;
}
var h = {
    breakpoints: r.breakpoints,
    colors: t.DEFAULT_COLORS,
    spacing: function spacing() {
      var e,
        r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
        t = {
          get: function get() {
            return e = c[r] || 4 * r;
          },
          px: function px() {
            return "".concat(e, "px");
          },
          rem: function rem() {
            return u["default"](this.px(e));
          }
        };
      return e = t.get(r), t;
    },
    effects: p,
    useMediaQuery: d,
    zIndex: g
  },
  w = function w(e, t) {
    return x(x({}, h), {}, {
      pageLoadWindowWidth: e,
      pageLoadWindowHeight: t
    }, function (e) {
      return {
        xsmallUp: function xsmallUp() {
          return d(r.breakpoints.up("xsmall"), r.breakpoints.defaultMatchUp(r.breakpoints.values.xsmall, e));
        },
        smallUp: function smallUp() {
          return d(r.breakpoints.up("small"), r.breakpoints.defaultMatchUp(r.breakpoints.values.small, e));
        },
        mediumUp: function mediumUp() {
          return d(r.breakpoints.up("medium"), r.breakpoints.defaultMatchUp(r.breakpoints.values.medium, e));
        },
        largeUp: function largeUp() {
          return d(r.breakpoints.up("large"), r.breakpoints.defaultMatchUp(r.breakpoints.values.large, e));
        },
        large1200Up: function large1200Up() {
          return d(r.breakpoints.up("large1200"), r.breakpoints.defaultMatchUp(r.breakpoints.values.large1200, e));
        },
        xlargeUp: function xlargeUp() {
          return d(r.breakpoints.up("xlarge"), r.breakpoints.defaultMatchUp(r.breakpoints.values.xlarge, e));
        },
        xxlargeUp: function xxlargeUp() {
          return d(r.breakpoints.up("xxlarge"), r.breakpoints.defaultMatchUp(r.breakpoints.values.xxlarge, e));
        },
        smallDown: function smallDown() {
          return d(r.breakpoints.down("small"), r.breakpoints.defaultMatchDown(r.breakpoints.values.small, e));
        },
        mediumDown: function mediumDown() {
          return d(r.breakpoints.down("medium"), r.breakpoints.defaultMatchDown(r.breakpoints.values.medium, e));
        },
        largeDown: function largeDown() {
          return d(r.breakpoints.down("large"), r.breakpoints.defaultMatchDown(r.breakpoints.values.large, e));
        },
        large1200Down: function large1200Down() {
          return d(r.breakpoints.down("large1200"), r.breakpoints.defaultMatchDown(r.breakpoints.values.large1200, e));
        },
        xlargeDown: function xlargeDown() {
          return d(r.breakpoints.down("xlarge"), r.breakpoints.defaultMatchDown(r.breakpoints.values.xlarge, e));
        },
        xxlargeDown: function xxlargeDown() {
          return d(r.breakpoints.down("xxlarge"), r.breakpoints.defaultMatchDown(r.breakpoints.values.xxlarge, e));
        },
        custom768820: function custom768820() {
          return d(r.breakpoints.between(768, 820), r.breakpoints.defaultMatchBetween(768, 820, e));
        },
        custom768810: function custom768810() {
          return d(r.breakpoints.between(768, 810), r.breakpoints.defaultMatchBetween(768, 810, e));
        },
        custom1070up: function custom1070up() {
          return d(r.breakpoints.up(1070), r.breakpoints.defaultMatchUp(1070, e));
        },
        custom2300Up: function custom2300Up() {
          return d(r.breakpoints.up(2300), r.breakpoints.defaultMatchUp(2300, e));
        },
        mediumToLarge: function mediumToLarge() {
          return d(r.breakpoints.between("medium", "large"), r.breakpoints.defaultMatchBetween(r.breakpoints.values.medium, r.breakpoints.values.large, e));
        },
        mediumToLarge1200: function mediumToLarge1200() {
          return d(r.breakpoints.between("medium", "large1200"), r.breakpoints.defaultMatchBetween(r.breakpoints.values.medium, r.breakpoints.values.large1200, e));
        },
        smallToMedium: function smallToMedium() {
          return d(r.breakpoints.between("small", "medium"), r.breakpoints.defaultMatchBetween(r.breakpoints.small, r.breakpoints.medium, e));
        },
        smallToLarge: function smallToLarge() {
          return d(r.breakpoints.between("small", "large"), r.breakpoints.defaultMatchBetween(r.breakpoints.small, r.breakpoints.large, e));
        }
      };
    }(e));
  },
  v = x(x({}, h), {}, {
    render: w
  });
exports["default"] = v, exports.render = w;